import { render, staticRenderFns } from "./CandidatesRemoveFromAcceptance.vue?vue&type=template&id=7b320ea5&lang=pug"
import script from "./CandidatesRemoveFromAcceptance.vue?vue&type=script&lang=js"
export * from "./CandidatesRemoveFromAcceptance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports